import type { ModalProps } from "antd";
import { useIsMobile } from "./useIsMobile";

/** Proprietà di Modal per mobile: schermo intero (width 100%, top 0, corpo scorrevole). Su desktop restituisce solo la larghezza. */
export function useModalProps(desktopWidth?: number | string): Pick<ModalProps, "width" | "style" | "styles"> {
  const mobile = useIsMobile();
  if (!mobile) return { width: desktopWidth };
  return {
    width: "100%",
    style: { top: 0, maxWidth: "100vw", margin: 0, padding: 0 },
    styles: {
      content: { borderRadius: 0, minHeight: "100dvh", display: "flex", flexDirection: "column" },
      body: { flex: 1, overflowY: "auto", overflowX: "hidden", maxHeight: "calc(100dvh - 120px)" },
      footer: { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "flex-end" },
    },
  };
}
